import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useFormatter } from '../../../core/formatter/use-formatter';
import { InvalidArgumentException } from '../../../domain/common/error-handling/exceptions';
import { Container } from '../../backend/openapi/api-types';

// Note: This is a duplication of /apps/backend/src/domain/request-form/types/field-types.ts
type ContainerMetaData = {
  value: Container;
  weight: number;
  label: (t: TFunction, value: number) => string;
};

// Note: This is a duplication of /apps/backend/src/domain/request-form/types/field-types.ts
const CONTAINER_TO_CONTAINER_META_DATA: Record<Container, ContainerMetaData> = {
  [Container.P02]: {
    value: Container.P02,
    weight: 2.5,
    label: (t, value) => t('article.containerSize.P', { value }),
  },
  [Container.P05]: {
    value: Container.P05,
    weight: 5,
    label: (t, value) => t('article.containerSize.P', { value }),
  },
  [Container.K10]: {
    value: Container.K10,
    weight: 10,
    label: (t, value) => t('article.containerSize.K', { value }),
  },
  [Container.K15]: {
    value: Container.K15,
    weight: 15,
    label: (t, value) => t('article.containerSize.K', { value }),
  },
  [Container.K20]: {
    value: Container.K20,
    weight: 20,
    label: (t, value) => t('article.containerSize.K', { value }),
  },
};

function mapToContainerEnum(container: Container): Container {
  if (!(container in Container)) {
    throw new InvalidArgumentException(`Invalid container: ${container}`);
  }

  return Container[container as keyof typeof Container];
}

export const useContainer = () => {
  const { t } = useTranslation();
  const { formatWeight } = useFormatter();

  function mapContainer(container: Container) {
    const containerEnum = mapToContainerEnum(container);
    const containerMetaData = CONTAINER_TO_CONTAINER_META_DATA[containerEnum];
    const formattedWeight = formatWeight(containerMetaData.weight);
    const label = containerMetaData.label(t, containerMetaData.weight);

    return {
      ...containerMetaData,
      label,
      formattedWeight,
    };
  }

  return { mapContainer };
};
